
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"20","viewBox":"0 0 192.756 192.756"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h192.756v192.756H0V0z"}}),_c('path',{attrs:{"d":"M183.449 85.182h-6.42s-11.121-2.751-15.133-3.554c-33.82-7.567-73.486-8.025-108.108-1.147-11.464 2.293-12.955 3.096-19.146 4.701h-5.961c21.553-7.911 45.628-10.318 68.442-11.35 29.578-.687 59.959 2.981 86.326 11.35zM8.504 118.199h12.267c11.234 0 19.719-7.566 23.387-17.77 2.637-7.223-.115-11.464-8.254-11.464H25.356L8.504 118.199zm20.177-23.845h4.815c4.585 0 5.388 2.866 3.898 7.108-2.293 6.19-7.796 11.35-14.331 11.35h-5.044l10.662-18.458zm13.184 23.845h6.42l16.853-29.233h-6.42l-16.853 29.233zm51.475-19.03c2.751-7.108-1.032-10.892-7.795-10.892-9.859 0-19.031 8.254-22.471 17.771-2.98 8.139.115 12.954 8.255 12.954 6.42 0 11.923-3.096 17.54-11.235h-6.42c-1.72 2.981-5.503 5.732-9.057 5.732-4.586 0-5.273-3.439-3.898-7.451 2.063-5.618 7.566-12.382 14.101-12.382 3.095 0 4.586 1.834 3.325 5.503h6.42zm42.533 19.03h6.076l12.953-23.272-5.617 23.272h4.93l20.865-23.272h.115l-13.871 23.272h6.076l16.852-29.233h-9.057l-18.916 21.209h-.115l5.504-21.209h-8.943l-16.852 29.233zM107.441 89.08h35.424l-16.508 29.119H90.818l16.623-29.119z","fill":"#2b2b2d"}}),_c('path',{attrs:{"d":"M100.906 105.703c-3.096 7.223.115 11.351 8.598 11.351 10.662 0 19.834-7.452 23.502-15.821 3.096-7.223-.572-11.006-8.826-11.006-10.203 0-19.719 7.222-23.274 15.476z","fill":"#fff"}}),_c('path',{attrs:{"d":"M105.721 106.162c2.523-5.962 9.287-12.955 17.541-12.955 5.848 0 6.535 3.669 4.701 8.025-2.523 5.731-9.516 12.84-17.426 12.84-5.848 0-6.65-3.783-4.816-7.91z","fill":"#cf402f"}})])])
          )
        }
      }
    